import AdapterSlider from './AdapterSlider'

export default AdapterSlider
